// The generic half of every feature package's host (#204): modals, the
// signed-in user and their permissions. A src/app/register-<x>.tsx spreads it
// into the package's own host:
//
//   createDayoffsModule({ ...hostBase, links: { account: paths.account }, … })
//
// The `satisfies` below is the check that the app's real hooks and registry
// still match the contract packages are written against
// (@vnetwork/datacentral-shell/host); a drift fails typecheck here, once,
// rather than in each register file.
import type {
    HostModalApi,
    HostSession,
} from '@vnetwork/datacentral-shell/host'
import { registerPackageModals } from '@/components/modals'
import { useModal } from '@/contexts/modal'
import useAuthStore from '@/stores/useAuthStore'
import usePermissionsStore from '@/stores/usePermissionsStore'
import type { EmployeeInfo } from '@/types/session'

const useCurrentEmployee = () => ({ employee: useAuthStore().employee })
const useIsAdmin = () => usePermissionsStore().isAdmin

export const hostBase = {
    useModal,
    registerModals: registerPackageModals,
    useCurrentEmployee,
    useIsAdmin,
} satisfies HostModalApi & HostSession<EmployeeInfo>
